<template>
    <div>
        <!-- Table Container Card -->
        <b-card no-body class="mb-0" data-test="details-table">
            <b-card-header tag="h1" class="border-bottom">
                   <div class="header-title">
                        <h1 class="mb-0">Director Interest Details</h1>

                        <div class="close-details">
                            <feather-icon
                                class="cursor-pointer"
                                icon="XIcon"
                                size="16"
                                @click="$emit('cancelView')"
                            />
                        </div>
                   </div>

                   <!-- Director Card Info -->
                    <div class="director-main-info mt-1 mx-auto">
                        <b-card
                            no-body
                            class="director-interest-logo mb-0 mt-1"
                        >
                            <b-card-body>
                                <div class="brief-user-info-box">
                                    <div class="d-flex">
                                        <span style="display: inline-block; width: 97px;">Director Name</span>
                                        <span class="dot px-1">:</span>
                                        <strong style="max-width: 350px">{{ directorDetails.name }}</strong>
                                    </div>
                                    <div class="d-flex">
                                        <span style="display: inline-block; width: 97px;">Director UID</span>
                                        <span class="dot px-1">:</span>
                                        <strong style="max-width: 350px">{{ directorDetails.userId }}</strong>
                                    </div>
                                    <div class="d-flex">
                                        <span style="display: inline-block; width: 97px;">Company</span>
                                        <span class="dot px-1">:</span>
                                        <strong style="max-width: 350px">{{ companyName }}</strong>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-card>
                    </div>  
                <!-- End Director Card Info -->
            </b-card-header>

            <loader v-if="isLoading" data-type="Table" class="custom-loading"/>

            <b-card-body>
                <div v-for="directorInterest in directorInterestViewList" :key="directorInterest.title">
                    <details-table
                        v-if="shouldShowDetails(directorInterest)"
                        ref="directorInterestViewTest"
                        :data-director-interest-details="directorInterest"
                        :payload-for-details-view="payloadForDetailsView"
                        @edit="edit"
                        @remove="remove"
                    />
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import {
    BCard,
    BCardHeader,
    BCardBody,
} from "bootstrap-vue";
import { mapGetters } from 'vuex';
import useDirectorInterestViewTable from './useDirectorInterestViewTable';
import DetailsTable from './DetailsTable.vue';

export default {
    components: {
        BCard,
        BCardBody,
        BCardHeader,
        DetailsTable,
    },

    props: {
        dataDirectorInterest: {
            type : Object,
            required: true
        }
    },

    data() {
        return {
            directorDetails : {
                name: this.dataDirectorInterest.director.name,
                userId: this.dataDirectorInterest.director.nric,
                directorStatus: this.dataDirectorInterest.director.directorStatus
            },
        };
    },

    computed: {
        ...mapGetters({
            companyName: 'company/fullCompanyName',
            isUserAdmin: "auth/isAdmin",
        }),
    },

    created() {
        this.fetchDirectorInterests(this.dataDirectorInterest.director.userId);

        // if user is not admin then don't show action column
        if(!this.isUserAdmin) {
            this.tableColumns.pop();
        }
    },

    methods: {
        edit(data) {
            this.$emit('edit', data, "edit");
        },

        remove(data) {
            this.$emit('remove', data);
        },

        shouldShowDetails(data) {
            let showDetails = false;

            Object.keys(data.body).forEach(
                key => {
                    if(data.body[key].length >= 1)
                        showDetails = true;
                }
            );

            return showDetails;
        }
    },

    setup() {
        const {
            totalDirectorInterests,
            isLoading,
            tableColumns,
            directorInterestViewList,
            fetchDirectorInterests,
            refDirectorInterestViewDetailsTable,
            localizeDirectorInterestDetails,
            refetchViewData,
        } = useDirectorInterestViewTable();

        const payloadForDetailsView = {
            isLoading,
            totalDirectorInterests,
            tableColumns,
            directorInterestViewList,
            fetchDirectorInterests,
            refDirectorInterestViewDetailsTable,
            localizeDirectorInterestDetails,
            refetchViewData
        };

        return {
            fetchDirectorInterests,
            tableColumns,

            directorInterestViewList,

            // UI
            isLoading,
            payloadForDetailsView,
        };
    }
};
</script>

<style lang="scss" scoped>
.director-main-info {
    max-width: 50%;
}

.director-main-info .card {
  border: none !important;
}

.director-main-info .card-body {
  border: 1px solid #ebe9f1 !important;
  box-shadow: 0px 0px 22px 2px #e3e3e3;
  border-radius: 10px;
  padding: 20px 10px;
}

.header-title {
  width: 100%;
  display: flex;
  justify-content: inherit;
}
</style>